import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

export default {
  getIncidents: async (options = {}) => {
    const {
      finds = {},
      orders = {},
      params = {},
    } = options;

    const findsParts = [];
    Object.entries(finds).forEach(([key, value]) => {
      if (value === '' || value === null || value === undefined) return;
      if (Array.isArray(value)) {
        value.forEach((v) => findsParts.push(`finds[${key}][]=${v}`));
      } else {
        findsParts.push(`finds[${key}]=${value}`);
      }
    });

    const ordersParts = [];
    Object.entries(orders).forEach(([key, value]) => {
      if (value === '' || value === null || value === undefined) return;
      ordersParts.push(`orders[${key}]=${value}`);
    });

    const otherParts = [];
    Object.entries(params).forEach(([key, value]) => {
      if (value === '' || value === null || value === undefined) return;
      otherParts.push(`${key}=${value}`);
    });

    const queryString = [...findsParts, ...ordersParts, ...otherParts].join('&');

    try {
      const response = await axiosInstance.get(`/alert/incident?${queryString}`, {
        cancelToken: getNewCancelToken(),
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching alert incidents:', error);
      throw error;
    }
  },
};
